export const designServiceCategoryId = 30
export const visitUnitId = 131
export const doneStatus = 8
